import React, { useState } from 'react';
import './ServiceAppointment.css';

// Имитация списка мастеров-приемщиков
const SPECIALISTS_DATA = [
    {
        id: 1,
        name: 'Жиижжгиев Жиижгии',
        role: 'Мастер-приемщик',
        avatar: 'https://images.remote.com/avatar1.png',
        slots: ['8:00', '9:00', '13:00', '14:00']
    },
    {
        id: 2,
        name: 'Джексон Джонсон',
        role: 'Мастер-приемщик',
        avatar: 'https://images.remote.com/avatar2.png',
        slots: ['8:00', '9:00', '10:00', '12:00']
    },
    {
        id: 3,
        name: 'Касимжон',
        role: 'Мастер-приемщик',
        avatar: 'https://images.remote.com/avatar3.png',
        slots: ['10:00', '11:00', '15:00', '16:00']
    }
];

const TIME_SLOTS_FOR_CALENDAR = [
    '8:00', '9:00', '10:00', '11:00',
    '12:00', '13:00', '14:00', '15:00',
    '16:00', '17:00', '18:00'
];

const ServiceAppointment = () => {
    const [step, setStep] = useState(1);
    const [selectedServiceCenter, setSelectedServiceCenter] = useState('');
    const [selectedDivision, setSelectedDivision] = useState('');
    const [serviceType, setServiceType] = useState('');
    
    // Переменные для шага 4 (Специалист / Дата и время)
    const [selectedSpecialist, setSelectedSpecialist] = useState(null);
    const [selectedTimeSlot, setSelectedTimeSlot] = useState('');
    const [selectedDate, setSelectedDate] = useState(null);

    // Состояние для управления модальным окном
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Данные финальной формы регистрации
    const [formData, setFormData] = useState({
        clientType: 'Физическое лицо',
        visitedBefore: 'Да',
        vin: '',
        plateNumber: '',
        companyName: '',
        unp: '',
        contactName: '',
        phone: '',
        email: '',
        workDescription: '',
        feedbackMethod: 'Нет'
    });

    const handleBack = () => {
        if (step > 1) setStep(step - 1);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Вместо стандартного alert открываем модальное окно
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        // Сброс на первый шаг при закрытии модального окна
        setStep(1);
    };

    return (
        <div className="srv-container">
            <h1 className="srv-main-title">ОНЛАЙН-ЗАПИСЬ НА СЕРВИС</h1>

            {step > 1 && (
                <div className="srv-navigation">
                    <button className="srv-back-button" onClick={handleBack}>
                        <span>‹</span> Назад
                    </button>
                    <div className="srv-breadcrumbs">
                        <span>PREMIUM AUTO</span>
                        {step >= 3 && <span> / {selectedDivision}</span>}
                        {step >= 4 && <span> / {serviceType}</span>}
                    </div>
                </div>
            )}

            {/* Скрин 1: Выбор сервиса */}
            {step === 1 && (
                <div className="srv-step-wrapper">
                    <p className="srv-step-label">Выберите сервис</p>
                    <div className="srv-dealer-card" onClick={() => { setSelectedServiceCenter('PREMIUM AUTO'); setStep(2); }}>
                        <div className="srv-dealer-header">
                            <span className="srv-logo-text">PREMIUM AUTO</span>
                        </div>
                        <div className="srv-dealer-footer">
                            <span>г. Ташкент, Мирабадский район, ул. Авлио Ота 128</span>
                            <span className="srv-map-link">На карте</span>
                        </div>
                    </div>
                </div>
            )}

            {/* Скрин 2: Выбор подразделения */}
            {step === 2 && (
                <div className="srv-step-wrapper">
                    <p className="srv-step-label">Выберите подразделение</p>
                    <div className="srv-list-menu">
                        <div className="srv-menu-btn" onClick={() => { setSelectedDivision('Автомобили BMW'); setStep(3); }}>
                            <div className="srv-icon-placeholder bmw-logo-small"></div>
                            <span>Автомобили BMW</span>
                        </div>
                        <div className="srv-menu-btn" onClick={() => { setSelectedDivision('Мотоциклы BMW Motorrad'); setStep(3); }}>
                            <div className="srv-icon-placeholder motorrad-logo-small"></div>
                            <span>Мотоциклы BMW Motorrad</span>
                        </div>
                    </div>
                </div>
            )}

            {/* Скрин 3: Выбрать тип обслуживания */}
            {step === 3 && (
                <div className="srv-step-wrapper">
                    <p className="srv-step-label">Выберите причину обращения</p>
                    <div className="srv-list-menu">
                        <div className="srv-menu-btn" onClick={() => { setServiceType('Техническое обслуживание'); setStep(4); }}>
                            <div className="srv-icon-placeholder tool-icon"></div>
                            <span>Техническое обслуживание</span>
                        </div>
                        <div className="srv-menu-btn" onClick={() => { setServiceType('Техническое обслуживание по гарантии'); setStep(4); }}>
                            <div className="srv-icon-placeholder shield-icon"></div>
                            <span>Техническое обслуживание по гарантии</span>
                        </div>
                    </div>
                </div>
            )}

            {/* Скрин 4: Выбор маршрута (Специалист или Дата) */}
            {step === 4 && (
                <div className="srv-step-wrapper">
                    <p className="srv-step-label">Выберите причину обращения</p>
                    
                    <div className="srv-routing-options">
                        <div className="srv-route-card active" onClick={() => setStep(4.1)}>
                            <div className="srv-route-icon user-circle"></div>
                            <span>Выберите сотрудника</span>
                        </div>
                    </div>
                </div>
            )}

            {/* Скрин 5: Выбор специалиста */}
            {step === 4.1 && (
                <div className="srv-step-wrapper">
                    <p className="srv-step-label">Выберите мастера-приемщика</p>
                    
                    <div className="srv-specialists-list">
                        {SPECIALISTS_DATA.map((spec) => (
                            <div 
                                key={spec.id} 
                                className={`srv-spec-card ${selectedSpecialist?.id === spec.id ? 'selected' : ''}`}
                                onClick={() => {
                                    setSelectedSpecialist(spec);
                                    setSelectedTimeSlot('');
                                }}
                            >
                                <div className="srv-spec-header-row">
                                    <div className="srv-spec-avatar"></div>
                                    <span className="srv-spec-name">{spec.name}</span>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="srv-action-placement">
                        {selectedSpecialist && selectedTimeSlot ? (
                            <button className="srv-primary-blue-btn" onClick={() => setStep(5)}>
                                Далее ➔
                            </button>
                        ) : (
                            <button className="srv-primary-blue-btn" onClick={() => setStep(4.2)}>
                                Выбрать дату и время
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Скрин 7: Календарь и слоты времени */}
            {step === 4.2 && (
                <div className="srv-step-wrapper">
                    {selectedSpecialist && (
                        <div className="srv-attached-spec-badge">
                            <div className="srv-spec-avatar micro"></div>
                            <span>{selectedSpecialist.name}</span>
                        </div>
                    )}
                    <h2 className="srv-calendar-month">Июль 2026</h2>
                    <div className="srv-calendar-table">
                        {['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'].map(d => <div key={d} className="srv-th">{d}</div>)}
                        <div className="srv-td empty"></div>
                        <div className="srv-td empty"></div>
                        {Array.from({ length: 31 }).map((_, i) => {
                            const day = i + 1;
                            return (
                                <div 
                                    key={day} 
                                    className={`srv-td ${selectedDate === day ? 'active-day' : ''} ${day === 23 ? 'current' : ''}`}
                                    onClick={() => setSelectedDate(day)}
                                >
                                    {day}
                                </div>
                            );
                        })}
                    </div>

                    {selectedDate && (
                        <div className="srv-time-slots-section">
                            <p className="srv-step-label">Выберите время</p>
                            <div className="srv-time-slots-grid">
                                {TIME_SLOTS_FOR_CALENDAR.map(slot => (
                                    <button 
                                        key={slot} 
                                        className={`srv-time-grid-btn ${selectedTimeSlot === slot ? 'active' : ''}`}
                                        onClick={() => setSelectedTimeSlot(slot)}
                                    >
                                        {slot}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}

                    {selectedTimeSlot && (
                        <button className="srv-primary-blue-btn margin-top-all" onClick={() => setStep(5)}>
                            Далее ➔
                        </button>
                    )}
                </div>
            )}

            {/* Скрин 6 и 8: Форма регистрации */}
            {step === 5 && (
                <form onSubmit={handleSubmit} className="srv-step-wrapper srv-registration-form">
                    
                    <div className="srv-form-group">
                        <label>Субъект</label>
                        <div className="srv-radio-flex">
                            {['Физическое лицо', 'Юридическое лицо'].map(t => (
                                <label key={t} className="srv-radio-item">
                                    <input type="radio" name="clientType" value={t} checked={formData.clientType === t} onChange={handleInputChange} />
                                    <span>{t}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    <div className="srv-form-group">
                        <label>Обслуживались ранее в PREMIUM AUTO?</label>
                        <div className="srv-radio-flex">
                            {['Да', 'Нет'].map(o => (
                                <label key={o} className="srv-radio-item">
                                    <input type="radio" name="visitedBefore" value={o} checked={formData.visitedBefore === o} onChange={handleInputChange} />
                                    <span>{o}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    <div className="srv-form-group">
                        <label>VIN *</label>
                        <input type="text" name="vin" placeholder="1234567890ABCDEFG" required value={formData.vin} onChange={handleInputChange} />
                    </div>

                    <div className="srv-form-group">
                        <label>Гос. номер *</label>
                        <input type="text" name="plateNumber" placeholder="01 A 777 AA" required value={formData.plateNumber} onChange={handleInputChange} />
                    </div>

                    {formData.clientType === 'Юридическое лицо' && (
                        <>
                            <div className="srv-form-group">
                                <label>Наименование *</label>
                                <input type="text" name="companyName" required value={formData.companyName} onChange={handleInputChange} />
                            </div>
                            <div className="srv-form-group">
                                <label>ИНН / УНП *</label>
                                <input type="text" name="unp" required value={formData.unp} onChange={handleInputChange} />
                            </div>
                        </>
                    )}

                    <div className="srv-form-group">
                        <label>Имя контактного лица *</label>
                        <input type="text" name="contactName" required value={formData.contactName} onChange={handleInputChange} />
                    </div>

                    <div className="srv-form-group">
                        <label>Телефон *</label>
                        <div className="srv-uzb-phone-wrapper">
                            <span className="srv-flag-icon">🇺🇿</span>
                            <span className="srv-phone-prefix">+998</span>
                            <input 
                                type="tel" 
                                name="phone" 
                                placeholder="(90) 123-45-67" 
                                required 
                                value={formData.phone} 
                                onChange={handleInputChange} 
                            />
                        </div>
                    </div>

                    <div className="srv-form-group">
                        <label>Email</label>
                        <input type="email" name="email" value={formData.email} onChange={handleInputChange} />
                    </div>

                    <div className="srv-form-group">
                        <label>Укажите перечень работ *</label>
                        <textarea name="workDescription" rows="4" required value={formData.workDescription} onChange={handleInputChange}></textarea>
                    </div>

                    {/* Сводка записи */}
                    <div className="srv-appointment-summary-widget">
                        <h3 className="srv-widget-date-title">
                            Ваша запись на {selectedDate ? (selectedDate < 10 ? `0${selectedDate}` : selectedDate) : '03'}.07 (Пятница), {selectedTimeSlot}
                        </h3>
                        {selectedSpecialist && (
                            <div className="srv-widget-master-info">
                                <div className="srv-widget-avatar"></div>
                                <div>
                                    <p className="srv-widget-name">{selectedSpecialist.name}</p>
                                    <p className="srv-widget-role">{selectedSpecialist.role}</p>
                                    <p className="srv-widget-dep">{serviceType} [{selectedDivision}]</p>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="srv-form-group">
                        <label className="srv-heading-label">Если у вас остались вопросы, выберите канал для связи</label>
                        <div className="srv-radio-inline-row">
                            {['Нет', 'Да (телефон)', 'Viber', 'Telegram', 'Email'].map(ch => (
                                <label key={ch} className="srv-radio-item">
                                    <input type="radio" name="feedbackMethod" value={ch} checked={formData.feedbackMethod === ch} onChange={handleInputChange} />
                                    <span>{ch}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    <p className="srv-form-required-text">* Обязательные для заполнения поля</p>

                    <button type="submit" className="srv-primary-blue-btn srv-form-submit">
                        Отправить
                    </button>
                </form>
            )}

            {/* --- МОДАЛЬНОЕ ОКНО ПОДТВЕРЖДЕНИЯ --- */}
            {isModalOpen && (
                <div className="modal-overlay" onClick={handleCloseModal}>
                    <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-close-btn" onClick={handleCloseModal}>&times;</button>
                        
                        <div className="modal-header">
                            <div className="modal-icon-success">✓</div>
                            <h2>Заявка успешно отправлена!</h2>
                        </div>

                        <div className="modal-body">
                            <div className="modal-info-row">
                                <span>Сервис:</span>
                                <strong>{selectedServiceCenter} ({selectedDivision})</strong>
                            </div>
                            <div className="modal-info-row">
                                <span>Услуга:</span>
                                <strong>{serviceType}</strong>
                            </div>
                            <div className="modal-info-row">
                                <span>Мастер:</span>
                                <strong>{selectedSpecialist?.name || 'Не выбран'}</strong>
                            </div>
                            <div className="modal-info-row">
                                <span>Дата и время:</span>
                                <strong>{selectedDate ? `${selectedDate < 10 ? '0' + selectedDate : selectedDate}.07.2026` : '03.07.2026'} в {selectedTimeSlot}</strong>
                            </div>
                            <div className="modal-info-row">
                                <span>Автомобиль (VIN):</span>
                                <strong>{formData.vin}</strong>
                            </div>
                            <div className="modal-info-row">
                                <span>Гос. номер:</span>
                                <strong>{formData.plateNumber}</strong>
                            </div>
                            <div className="modal-info-row">
                                <span>Клиент:</span>
                                <strong>{formData.contactName}</strong>
                            </div>
                            <div className="modal-info-row">
                                <span>Телефон:</span>
                                <strong>+998 {formData.phone}</strong>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button className="modal-primary-btn" onClick={handleCloseModal}>
                                Отлично
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ServiceAppointment;